const moduleExports = {};

moduleExports.onServiceWorkerUpdateReady = () => window.location.reload(true);

module.exports = moduleExports;
